// General
export const APP_NAME = "TrypScore - API Documentation";

// Signin
export const SIGNIN_BAD_EMAIL = "Invalid email format";
export const SIGNIN_BTN = "Sign in";
export const SIGNIN_NO_ACCESS = "Sorry, you do not have access to this service";
export const SIGNIN_BAD_CREDS = "Invalid email or password";

//Form
export const FRM_EMAIL_REQUIRED = "Email is required";
export const FRM_PW_REQUIRED = "Password is required";

// Display
export const VIEWS = ["mobile", "tablet", "desktop"];

export const HEADER_HEIGHT = "4.5rem";
